<script>
import elementState from "./elementstate.vue";

export default {
    name: "publish-layer-select",
    components: {elementState},
    props: {
        activeLayerIndex: Number,
        selectableLayers: {}
    },
    computed: {
        translations() {
            return {
                selectALayer: Lang.langGet("Select a layer...").removeDotsAtEnd(),
                layer: Lang.langChoice("Layer|Layers", 1)
            }
        },
        prefix() {
            return `${this.translations.layer}:`
        }
    }
}
</script>

<template>
    <div class="w-100">
        <v-autocomplete
            :value="activeLayerIndex"
            :aria-label="translations.selectALayer"
            dense outlined hide-details
            :items="selectableLayers"
            :prefix="prefix"
            @input="$emit('input', $event)"
            @change="$emit('change', $event)"
        >
            <template #item="{item, attrs, on}">
                <div class="publish-layer-select-item" v-bind="attrs" v-on="on">
                    <element-state :state="item.state" colored-shadow size="small" />
                    <v-list-item-title v-html="item.text"></v-list-item-title>
                    <v-icon v-if="item.is_calendar">far fa-calendar-day</v-icon>
                </div>
            </template>
        </v-autocomplete>
    </div>
</template>

<style scoped>
    .publish-layer-select-item {
        display: flex;
        align-items: center;
        gap: 8px;
        padding-block: 8px;
        justify-content: space-between;
        width: 100%;
    }
</style>
